import { isSelectedMnx, getDallesMnhMntRapide } from "./utilsMap";

import Stroke from "ol/style/Stroke";
import {getFeature} from "ol/layer/Vector";

function removeDalleInPolygon(dalle,polygonSelect,indexDalle) {
    polygonSelect.forEach(polygon => {
        polygon.dalle.forEach((dalleInPolygon, index)=>{
            if (dalle.values_.properties.polygon===dalleInPolygon.values_.properties.polygon) {
                polygon.dalle.splice(index, 1)
            }
        })
    });
    return polygonSelect
}

async function getDalleIntersectPolygon(polygonGeometry, polygonId, listDalleSelect, vectorSouceGridDalleFeature) {

  let dalleIntersectPolygon = []
  for (let index = 0; index < vectorSouceGridDalleFeature.length; index++) {
    if (polygonGeometry.intersectsExtent(vectorSouceGridDalleFeature[index].values_.geometry.extent_)){
      if (!isSelectedMnx(vectorSouceGridDalleFeature[index].values_.id, listDalleSelect)) {
        const [dalleMnh, dalleMnt] = await getDallesMnhMntRapide(vectorSouceGridDalleFeature[index].values_.mns)
        dalleIntersectPolygon.push({"dalle" : vectorSouceGridDalleFeature[index], "polygonId": polygonId, "dalleMnh": dalleMnh,"dalleMnt": dalleMnt})
      }
    }
    
  }
vectorSouceGridDalleFeature.forEach(async (dalle)=>{
    
  })

  return dalleIntersectPolygon
}

export {removeDalleInPolygon, getDalleIntersectPolygon}